<div class="modal-title">
  <div class="flex justify-between items-center">
    <div>
      @if (title) {
        <h1 class="modal-title">
          {{ title }}
          @if (hasTour) {
            <app-nicky-button variant="text" size="extra-small" class="ml-2" (click)="onTour()">
              <mat-icon svgIcon="help-book" id="bookIcon"></mat-icon>
            </app-nicky-button>
          }
        </h1>
      }

      @if (subtitle) {
        <h3 class="modal-subtitle">{{ subtitle }}</h3>
      }
    </div>
    <app-nicky-button variant="text" size="small" iconLeft="ph ph-x" class="self-start" (click)="onClose()">
    </app-nicky-button>
  </div>
</div>
